"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const meStateHOAQuery = (0, graphql_tag_1.default)`
  query me_state_hoa {
    me {
      state {
        hoa {
          id
          name
          housesType
          structureType
          code
          proportionOwnershipSymbol
          address
          allowContractDownload
          buildingCount
          lat
          lng
        }
      }
    }
  }
`;
exports.default = meStateHOAQuery;